export enum ChatUpdateType {
  ChatStarted = "chatStarted",
  ChatFinished = "chatFinished",
  ChatMessageStarted = "chatMessageStarted",
  ChatMessageCompleted = "chatMessageCompleted",
  ChatMessageFailed = "chatMessageFailed",
  ChatMessageContentUpdated = "chatMessageContentUpdated",
  ChatMessageContentRevoked = "chatMessageContentRevoked",
  ChatMessageCancelled = "chatMessageCancelled",
}
